module.exports = "<app-navigation></app-navigation>\n\n<app-header></app-header>\n<div class=\"wrap\" style=\"padding-left: 25px;\">\n\t<h2 class=\"page-title\">\n\t\tInvoices <small>Statistics and more</small>\n\t</h2>\n\t<div class=\"row\">\n\t\t<div class=\"table-responsive\"></div>\n\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/invoices/invoices.component.html
// module id = 429
// module chunks = 1